export function isCardEmpty(card) {
    return !Object.keys(card)?.length || Object.values(card).some((item) => !item);
}
export function isTwoCardsEmpty(props) {
    return !props.cards?.length;
}
